import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoSemanaMultiSelectComponent } from './novo-semana-multi-select.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoSemanaMultiSelectComponent],
  exports: [NovoSemanaMultiSelectComponent],
})
export class NovoSemanaMultiSelectModule {}
